@if (loading()) {
  <p-skeleton height="12rem"></p-skeleton>
} @else if (error()) {
  <p-message severity="error" text="Loading the onboarding answers failed. Please try again."></p-message>
} @else if (onboarding(); as onboarding) {
  <p-card header="Onboarding">
    @if (isEmpty()) {
      <p class="empty">Onboarding not started.</p>
    } @else {
      <dl class="answers">
        @for (row of singleRows(); track row.question) {
          <div class="answer-row">
            <dt>{{ row.question }}</dt>
            <dd>{{ row.answer ?? '—' }}</dd>
          </div>
        }
        @for (row of multiRows(); track row.question) {
          <div class="answer-row">
            <dt>{{ row.question }}</dt>
            <dd>
              @if (row.answers.length) {
                @for (answer of row.answers; track answer) {
                  <p-tag class="multi-chip" severity="secondary" [value]="answer"></p-tag>
                }
              } @else {
                None selected
              }
            </dd>
          </div>
        }
        @if (termsLine(); as terms) {
          <div class="answer-row">
            <dt>Terms accepted</dt>
            <dd>{{ terms }}</dd>
          </div>
        }
      </dl>
    }
  </p-card>
}
